<!--
 * @Author: 
 * @LastEditTime: 2022-07-26 16:38:08
 * @Description: 
-->
<template>
  <div class="circle-item">
    <el-table
      :data="warnningList"
      class="w-100"
      border
      :highlight-current-row="true"
      height="250"
      ref="multipleTable"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="sepNo" width="75" sortable label="序号"></el-table-column>
      <el-table-column prop="code" show-overflow-tooltip sortable label="位号"></el-table-column>
      <el-table-column
        prop="warnnings"
        sortable
        show-overflow-tooltip
        label="报警信息"
      ></el-table-column>
      <el-table-column prop="time" show-overflow-tooltip sortable label="时间"></el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'warningsList',
  data() {
    return {
      warnningList: [
        {
          sepNo: '1',
          code: '祥瑞苑小区4号',
          warnnings: '电压超限报警',
          time: '2022-7-23 09:00:00',
        },
        {
          sepNo: '2',
          code: '祥瑞苑小区4号',
          warnnings: '电压超限报警',
          time: '2022-7-24 09:30:00',
        },
        {
          sepNo: '3',
          code: '祥瑞苑小区4号',
          warnnings: '电压超限报警',
          time: '2022-7-25 10:00:00',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>

.circle-item {
  position: relative;
}
@import './specialStyle.scss';

</style>
